export default "__VITE_ASSET__DPOaN9$5__"